import * as store from '@attain-apps/fe/web/main/lib/store'

import type { State } from './state'

/**
 * Core actions for the plugin manager
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /**
     * Overwrites the {@link State.pluginsStatus}
     */
    setPluginsStatus: store.actions.standalone({
      data: store.actions.Data.asIs<Pick<State, 'pluginsStatus'>>(),
      reducerDeprecated: (state, { pluginsStatus }) =>
        ({ ...state, pluginsStatus }) satisfies State,
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
